import { useMemo } from 'react';

import { Button } from 'UIPackage/MainModule/components/Button';

import styles from './PublicationWarningModal.module.scss';
import { Modal } from './Modal';

interface IPublicationWarningModalProps {
  onClose: () => void;
  mt: string;
}

export const PublicationWarningModal = ({ onClose, mt }: IPublicationWarningModalProps) => {
  const message = useMemo(() => {
    switch (mt) {
      case 'knm':
        return 'Паспорт мероприятия не сформирован, проведение контрольного (надзорного) мероприятия невозможно';
      case 'pm':
        return 'Паспорт мероприятия не сформирован, проведение профилактического мероприятия невозможно';
      case 'decision':
        return 'Паспорт решения не сформирован, проведение мероприятия невозможно';
      default:
        return 'Паспорт не сформирован, проведение контрольного (надзорного) мероприятия невозможно';
    }
  }, [mt]);

  return (
    <Modal modalBodyClassName={styles.ModalBody} visible={true} onClose={onClose}>
      <div className={styles.Header}>
        <h4 className={styles.Title}>Уведомление</h4>
      </div>
      <div className={styles.Body}>
        <div className={styles.Content}>
          <p>{message}</p>
        </div>
      </div>
      <div className={styles.Footer}>
        <Button className={styles.FilterButton} color="primary" type="button" onClick={onClose} text="ОК" />
      </div>
    </Modal>
  );
};
